export const SET_EMAIL_RECEIVERS = 'SET_EMAIL_RECEIVERS'
export const SET_EMAIL_RECEIVERS_LOADING = 'SET_EMAIL_RECEIVERS_LOADING'
